import _, { Dictionary } from "lodash";
import {
    httpGet as genericHttpGet,
    httpPost as genericHttpPost,
    httpPatch as genericHttpPatch,
    httpPut as genericHttpPut,
    httpDelete as genericHttpDelete,
    GenericHttpResponse
} from './generic';

export interface CallResult {

}

export type ApiResponse = GenericHttpResponse;

export interface RequestConf {
    asBlob?: boolean
}

/**
 * GET -----------------------------------------------
 *
 * @param pathTpl a template from OpenAPI doc
 * @param pathParams path params
 * @param queryParams query params
 */
const httpGet: (
    pathTpl: string,
    pathParams: Dictionary<string>,
    queryParams: Dictionary<string>,
    conf?: RequestConf
) => Promise<ApiResponse> = async (
    pathTpl,
    pathParams,
    queryParams,
    conf = {}
) => {
        return genericHttpGet(`/api${pathTpl}`, pathParams, queryParams, conf);
    }

/**
 * POST -----------------------------------------------
 *
 * @param pathTpl a template from OpenAPI doc
 * @param pathParams path params
 * @param queryParams query params
 * @param body body
 */
const httpPost: (
    pathTpl: string,
    pathParams: Dictionary<string>,
    queryParams: Dictionary<string>,
    body: any,
    conf?: RequestConf
) => Promise<ApiResponse> = async (
    pathTpl,
    pathParams,
    queryParams,
    body,
    conf = {}
) => {
        return genericHttpPost(`/api${pathTpl}`, pathParams, queryParams, body, conf);
    }

/**
 * PUT -----------------------------------------------
 * 
 * @param pathTpl a template from OpenAPI doc 
 * @param pathParams path params
 * @param queryParams query params
 * @param body body
 */
const httpPut: (
    pathTpl: string,
    pathParams: Dictionary<string>,
    queryParams: Dictionary<string>,
    body: any,
    conf?: RequestConf
) => Promise<ApiResponse> = async (
    pathTpl,
    pathParams,
    queryParams,
    body,
    conf = {}
) => {
        return genericHttpPut(`/api${pathTpl}`, pathParams, queryParams, body, conf);
    }

/**
 * DELETE -----------------------------------------------
 *
 * @param pathTpl a template from OpenAPI doc
 * @param pathParams path params
 * @param queryParams query params
 * @param body body
 */
const httpDelete: (
    pathTpl: string,
    pathParams: Dictionary<string>,
    queryParams: Dictionary<string>,
    conf?: RequestConf
) => Promise<ApiResponse> = async (
    pathTpl,
    pathParams,
    queryParams,
    conf = {}
) => {
        return genericHttpDelete(`/api${pathTpl}`, pathParams, queryParams, conf);
    }
/**
 * PATCH -----------------------------------------------
 *
 * @param pathTpl a template from OpenAPI doc
 * @param pathParams path params
 * @param queryParams query params
 * @param body body
 */
const httpPatch: (
    pathTpl: string,
    pathParams: Dictionary<string>,
    queryParams: Dictionary<string>,
    body: any,
    conf?: RequestConf
) => Promise<ApiResponse> = async (
    pathTpl,
    pathParams,
    queryParams,
    body,
    conf = {}
) => {
        return genericHttpPatch(`/api${pathTpl}`, pathParams, queryParams, body, conf);
    }

export { httpGet, httpPost, httpPut, httpPatch, httpDelete }
